import type { FaireProductEntity } from "../../entity_types/product";

export const homemade_ish_1: FaireProductEntity = {
  token: "homemade-ish-1",
  type: "product",
  name: "Dry Cookie Mix - Starter Kit",
  brandName: "Homemade-ish",
  imageUrl:
    "https://cdn.prerelease.faire.dev/fastly/e1b6ea6bf119ef548f6986675cad3959584a923e79ef33fe5975abed0d56a9f1.webp",
  priceDollars: 16,
  msrpDollars: 26,
  freeShipping: false,
  isBestseller: false,
  description: "",
  tags: [],
  inStock: true,
  categoryTokens: ["cat_food-drink"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "legacy-products-migration",
  },
};
